import React from 'react';
import useStore from '../../store';
import SafeCracker from './games/safecracker/SafeCracker';
import DetectiveQuiz from './games/quiz/DetectiveQuiz';
import CrimeScene from './games/crimescene/CrimeScene';
import BombDefusal from './games/bomb/BombDefusal';
import SlidingPuzzle from './games/sliding/SlidingPuzzle';
import Tetris from './games/tetris/Tetris';
import Slovodel from './games/slovodel/Slovodel';
import WordDuel from './games/wordduel/WordDuel';
import Minesweeper from './games/minesweeper/Minesweeper';
import Garage from './games/garage/Garage'; // Import
import Game2048 from './games/game2048/Game2048'; // Import 2048
import Sudoku from './games/sudoku/Sudoku'; // Import Sudoku
import Piano from './games/piano/Piano'; // Import Piano
import Snake from './games/snake/Snake'; // Import Snake
import Balda from './games/balda/Balda'; // Import Balda
import Wordle from './games/wordle/Wordle'; // Import Wordle

const MiniGameRouter = ({ gameType, onClose, timeLeft }) => {
  const socket = useStore(state => state.socket);

  // Выбор компонента
  const games = {
      safeCracker: SafeCracker,
      quiz: DetectiveQuiz,
      crimeScene: CrimeScene,
      bombDefusal: BombDefusal,
      slidingPuzzle: SlidingPuzzle,
      tetris: Tetris,
      slovodel: Slovodel,
      wordDuel: WordDuel,
      minesweeper: Minesweeper,
      garage: Garage, // Register
      game2048: Game2048, // Register 2048
      sudoku: Sudoku, // Register Sudoku
      piano: Piano, // Register Piano
      snake: Snake, // Register Snake
      balda: Balda, // Register Balda
      wordle: Wordle // Register Wordle
  };

  const Component = games[gameType];

  if (Component) {
      return <Component socket={socket} onClose={onClose} timeLeft={timeLeft} />;
  }

  return null;
};

export default MiniGameRouter;